import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import * as actionTypes from "../../../store/actions/actionTypes";
import useBookingListNavigation from "../../../utils/bookingListNavigation";
import {bookingListSet} from "../../../store/actions/bookingList";

const BookingList_Search = () => {
    const {pushBookingListUrl} = useBookingListNavigation();
    const dispatch = useDispatch();
    const {keyword, status, page, filter, sortColumn, sortMode} = useSelector(state => state.bookingList);
    const [searchValue, setSearchValue] = useState('');
    const bookingListVars = useSelector(state => state.bookingList);
    const selectedHospital = useSelector(state => state.auth.selectedHospital);

    useEffect(() => {
        if (keyword) {
            setSearchValue(keyword);
        } else {
            setSearchValue('');
        }
    }, [keyword]);

    const searchEnabled = () => (searchValue.length > 1);

    const search = event => {
        if (searchEnabled) {
            dispatch(bookingListSet(selectedHospital.id, status, searchValue, filter, page, sortColumn, sortMode));
        }
        event.preventDefault();
    }

    return (
        <div className={`search-holder${keyword ? ' search-active' : ''}`}>
            <form className="search-form" onSubmit={search}>
                <div className="input-row">
                    <input type="search" className="form-control" placeholder="Search..." onChange={(event) => setSearchValue(event.target.value)} value={searchValue} />
                </div>
                <button className="btn btn-sm btn-search" disabled={!searchEnabled()} onClick={search}><i className="icon ico-zoom" /></button>
            </form>
        </div>
    );
}

export default BookingList_Search;